import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaUser, FaSignOutAlt } from 'react-icons/fa';

const ProfileMenu = () => {
  const [open, setOpen] = useState(false);
  const [student, setStudent] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const storedStudent = localStorage.getItem('student');
    if (storedStudent) {
      setStudent(JSON.parse(storedStudent));
    }
  }, []);

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('student');
    navigate('/student-login');
  };

  const handleNavigation = (path) => {
    setOpen(false);
    navigate(path);
  };

  if (!student) return null;

  return (
    <div style={{ position: 'relative' }}>
      <div
        onClick={() => setOpen(!open)}
        style={{
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          padding: '0.5rem',
          borderRadius: '12px',
          backgroundColor: '#f9fafb',
          color: '#1f2937',
        }}
      >
        <img
          src={student.image || 'https://i.pravatar.cc/40'}
          alt="Student Profile"
          style={{ borderRadius: '50%', marginRight: '8px', width: '40px', height: '40px' }}
        />
        <div>
          <div style={{ fontWeight: '600', fontSize: '1rem' }}>{student.fullName}</div>
          <div style={{ fontSize: '12px', color: '#6B7280' }}>Student</div>
        </div>
      </div>

      {open && (
        <div
          style={{
            position: 'absolute',
            top: '70px',
            right: 0,
            width: '220px',
            background: '#fff',
            boxShadow: '0 0 20px rgba(0, 0, 0, 0.08)',
            borderRadius: '16px',
            overflow: 'hidden',
            zIndex: 1000,
          }}
        >
          <div style={{ padding: '10px', borderBottom: '1px solid #ccc' }}>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <img
                src={student.image || 'https://i.pravatar.cc/40'}
                alt="Student Profile"
                style={{ borderRadius: '50%', marginRight: '10px', width: '40px', height: '40px' }}
              />
              <div>
                <div style={{ fontWeight: '600', fontSize: '1rem' }}>{student.fullName}</div>
                <div style={{ fontSize: '12px', color: '#6B7280' }}>Student</div>
              </div>
            </div>
          </div>

          <div style={{ padding: '10px' }}>
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                marginBottom: '8px',
                cursor: 'pointer',
                padding: '0.5rem',
                borderRadius: '8px',
                transition: 'background-color 0.3s',
              }}
              onClick={() => handleNavigation('/student/account')}
              onMouseOver={(e) => (e.target.style.backgroundColor = '#f9fafb')}
              onMouseOut={(e) => (e.target.style.backgroundColor = 'transparent')}
            >
              <FaUser style={{ marginRight: '8px', color: '#3b82f6' }} /> My Account
            </div>

            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                cursor: 'pointer',
                padding: '0.5rem',
                borderRadius: '8px',
                transition: 'background-color 0.3s',
              }}
              onClick={handleLogout}
              onMouseOver={(e) => (e.target.style.backgroundColor = '#f9fafb')}
              onMouseOut={(e) => (e.target.style.backgroundColor = 'transparent')}
            >
              <FaSignOutAlt style={{ marginRight: '8px', color: '#3b82f6' }} /> Log out
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ProfileMenu;
